<div cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary=".cdk-overlay-container">
  <div cdkDragHandle class="flex justify-between items-baseline pr-4">
    <h2 mat-dialog-title>Notices</h2>
    <button type="button" mat-icon-button class="leading-none" mat-dialog-close><mat-icon>close</mat-icon></button>
  </div>

  <mat-divider></mat-divider>

  <div mat-dialog-content>
    @if (errorMsg) {
      <app-sms-notice-banner type="alert" (closeBanner)="clearMessage(0)"><p>{{ errorMsg }}</p></app-sms-notice-banner>
    }

    <div class="flex">
      <ng-template><!-- Notifcation Labels - Left section --></ng-template>
      <div class="w-2/5 py-2 overflow-y-auto min-h-36 max-h-96">
        @if (notify_data == '') {
        } @else {
          <mat-selection-list [multiple]="false" [hideSingleSelectionIndicator]="true" class="pb-2">
            @for (noti of notify_data; track noti; let i = $index) {
              <span mat-subheader [innerHTML]="formatDate(noti.date)"></span>
              @for (data of noti.data; track data; let ii = $index) {
                <mat-list-option (click)="notificationMsg(data,i, ii)">
                  <span class="flex row gap-1 items-center">
                    @if (parentIndex == i && childIndex == ii) {
                      <mat-icon class="shrink-0">star</mat-icon>
                    }
                    @if (data.important_popup == '1') {
                      <mat-icon class="shrink-0">error</mat-icon>
                    }
                    <!-- <mat-icon>remove</mat-icon> -->
                    <span class="shrink italic inline-block">{{ commonService.truncateChar(data.notice_title, 46) }}</span>
                  </span>
                </mat-list-option>
              }
              <mat-divider></mat-divider>
            }
          </mat-selection-list>
        }

        <button type="button" mat-flat-button (click)="loadPastNotice()"><mat-icon>chevron_right</mat-icon> Load Past Notices</button>
        @if (pastNoticesMessage != '') {
          <p class="px-4" [innerHTML]="pastNoticesMessage"></p>
        }
      </div>

      <ng-template><!-- Notifcation Content - Right section --></ng-template>
      <div class="w-3/5 p-2 overflow-y-auto max-h-96 notification-display">
        @if (notify_data == '') {
          <p>There are no unread messages. You can access your notification history by selecting "Load Past Notices" on the left.</p>
        } @else {
          <div class="flex justify-between">
            @if (notice.dismissed_date) {
              <p>Read <span [innerHTML]="displayedMessageFrom(notice.dismissed_date)"></span></p>
            }
            @if (notice.start_date) {
              <p>Posted <span [innerHTML]="displayedMessageFrom(notice.start_date)"></span></p>
            }
          </div>
          <div>
            @if (notice.notice_title) {
              <p class="text-center font-bold text-2xl" [innerHTML]="notice.notice_title"></p>
            }
            @if (notice.notice_text) {
              <div #leadExportDiv (click)="checkForCMS(notice)" [innerHTML]="notice.notice_text | safeHtml"></div>
            }
          </div>
        }
      </div>
    </div>
  </div>

  <div mat-dialog-actions align="end">
    @if (displayingNoUnreadMessages && disableMarkAsRead) {
      <button type="button" mat-raised-button (click)="markAllRead()">Mark All As Read</button>
    }
    @if (displayingNoUnreadMessages && disableMarkAsRead) {
      <button type="button" mat-raised-button (click)="markRead(notice.notice_id || '')">Mark As Read</button>
    }
    <button type="button" mat-raised-button mat-dialog-close>Close</button>
  </div>
</div>
